import { accountSearchColumns } from '@/constants/search-columns';
import { SearchField, FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';

interface BasicInfoProps {
  searchFieldStates: {
    account: TaiKhoan | null;
    setAccount: (account: TaiKhoan | null) => void;
  };
}

const BasicInfo: React.FC<BasicInfoProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày</Label>
        <FormField name='ngay_ct' type='date' />
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Tài khoản</Label>
        <SearchField<TaiKhoan>
          columnDisplay={'code'}
          displayRelatedField={'name'}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          value={searchFieldStates.account?.code || ''}
          relatedFieldValue={searchFieldStates.account?.name || ''}
          onRowSelection={searchFieldStates.setAccount}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Loại số dư:</Label>
        <FormField
          name='loai_sd'
          type='select'
          options={[
            { value: '1', label: 'Đầu kỳ' },
            { value: '2', label: 'Cuối kỳ' }
          ]}
          className='w-44'
        />
      </div>
    </div>
  );
};

export default BasicInfo;
